export enum APPOINTMENT_STATUS {
  DRAFT = 'DRAFT',
  CREATED = 'CREATED',
  CANCELED_BY_CUSTOMER = 'CANCELED_BY_CUSTOMER',
}
